import { ColumnsType } from 'antd/es/table'
import { STATUS_ENUM_MAP } from './constants'

export const columns: ColumnsType<any> = [
  {
    title: '员工账号编码',
    dataIndex: 'userAccountCode',
    align: 'center',
  },
  {
    title: '员工姓名',
    dataIndex: 'username',
    align: 'center',
  },
  {
    title: '员工电话',
    dataIndex: 'mobile',
    align: 'center',
  },
  {
    title: '员工角色',
    dataIndex: 'userType',
    align: 'center',
  },
  {
    title: '账号状态',
    dataIndex: 'status',
    align: 'center',
    render: value => STATUS_ENUM_MAP.get(value) || '-',
  },
  {
    title: '账号当前可用额度',
    dataIndex: 'totalAmount',
    align: 'center',
    render: value => value?.toFixed(2),
  },
]
